// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"87":"industry","589":"park","683":"city","879":"call","996":"info"}[chunkId] + "." + {"87":"e41f11c6","589":"fdf433c2","683":"0d5153bb","879":"e68c6e92","996":"39c3078a"}[chunkId] + ".js";
};